import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "relative py-24 sm:py-32 min-h-fit" }
const _hoisted_2 = { class: "mx-auto max-w-7xl" }
const _hoisted_3 = { class: "mt-16 divide-y divide-gray-900/10 dark:divide-gray-100/10" }
const _hoisted_4 = { class: "ml-6 flex h-7 items-center" }

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import UiContainer from '@/components/ui/UiContainer.vue';
import UiTitle from '@/components/ui/UiTitle.vue';
import UiParagraph from '@/components/ui/UiParagraph.vue';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue';
import { MinusIcon, PlusIcon } from '@heroicons/vue/24/outline';


export default /*@__PURE__*/_defineComponent({
  __name: 'FAQSection',
  setup(__props) {

const { t } = useI18n();

// Computed
const faqs = computed(() => [
  {
    question: t('home.faq.question1'),
    answer: t('home.faq.answer1'),
  },
  {
    question: t('home.faq.question2'),
    answer: t('home.faq.answer2'),
  },
  {
    question: t('home.faq.question3'),
    answer: t('home.faq.answer3'),
  },
  {
    question: t('home.faq.question4'),
    answer: t('home.faq.answer4'),
  },
  {
    question: t('home.faq.question5'),
    answer: t('home.faq.answer5'),
  },
  {
    question: t('home.faq.question6'),
    answer: t('home.faq.answer6'),
  },
  {
    question: t('home.faq.question7'),
    answer: t('home.faq.answer7'),
  },
  {
    question: t('home.faq.question8'),
    answer: t('home.faq.answer8'),
  },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UiContainer, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(UiTitle, {
            size: "5xl",
            type: "h2",
            align: "left",
            code: _unref(t)('home.faq.tag')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('home.faq.title')), 1)
            ]),
            _: 1
          }, 8, ["code"]),
          _createElementVNode("dl", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faqs.value, (faq) => {
              return (_openBlock(), _createBlock(_unref(Disclosure), {
                key: faq.question,
                as: "div",
                class: "py-6 first:pt-0 last:pb-0"
              }, {
                default: _withCtx(({ open }) => [
                  _createElementVNode("dt", null, [
                    _createVNode(_unref(DisclosureButton), { class: "flex w-full items-start justify-between text-left text-gray-900 dark:text-gray-100" }, {
                      default: _withCtx(() => [
                        _createVNode(UiParagraph, {
                          class: "text-base/7 font-semibold",
                          size: "lg",
                          align: "left"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(faq.question), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("span", _hoisted_4, [
                          (!open)
                            ? (_openBlock(), _createBlock(_unref(PlusIcon), {
                                key: 0,
                                class: "size-6",
                                "aria-hidden": "true"
                              }))
                            : (_openBlock(), _createBlock(_unref(MinusIcon), {
                                key: 1,
                                class: "size-6",
                                "aria-hidden": "true"
                              }))
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createVNode(_unref(DisclosurePanel), {
                    as: "dd",
                    class: "mt-2 pr-12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(UiParagraph, {
                        size: "lg",
                        align: "left"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(faq.answer), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})